import thunkMiddleware from 'redux-thunk';

import { createStore, applyMiddleware, compose } from 'redux';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { updateApiContextBasedOnConfig } from 'actions/ApiCaller/Context';

import rootReducer from 'reducers';
import ApiErrorHandler from './apiErrorHandler';

const middlewares = [thunkMiddleware];

if (__DEV__) {
	// so that redux-logger doesn't get bundled up
	const loggerMiddleware = require('redux-logger')({ collapsed: true });
	middlewares.push(loggerMiddleware);
}
middlewares.push(ApiErrorHandler);

let initialState = null;

if (ExecutionEnvironment.canUseDOM) {
	initialState = window.__INITIAL_STATE__;
}

let store = null;

if (initialState) {
	if (__DEV__) {
		store = createStore(
			rootReducer,
			initialState,
			compose(
				applyMiddleware(...middlewares),
				window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
			)
		);
	} else {
		store = createStore(rootReducer, initialState, applyMiddleware(...middlewares));
	}

	updateApiContextBasedOnConfig(store.getState().config);

	delete window.__INITIAL_STATE__;
	let s = document.getElementById('is_script');
	s.parentNode.removeChild(s);
} else {
	store = createStore(rootReducer, applyMiddleware(...middlewares));
}

export default store;
